/* Ausgelagert am 07.09.2026 aus snippets/shipmentoo-warenkorb.liquid.
   Eingebettet waren es 42,3 kB auf JEDER Seite. Die Datei enthaelt kein
   Liquid und wird mit `defer` geladen - das Skript wartet ohnehin auf
   Elemente, die beim Einbinden noch nicht da sind. */

(function () {
  if (window.__smwWarenkorb) return;
  window.__smwWarenkorb = true;

  function drawer() { return document.querySelector('cart-drawer'); }

  /* Der Hinweis wird NICHT fest verdrahtet: der Shop zeigt je nach
     Umschalter Netto- oder Bruttopreise. Der Text richtet sich deshalb nach
     dem, was an den Posten steht - sonst stuende unten "inklusive", waehrend
     daneben Nettopreise laufen. */
  function steuerhinweis() {
    var d = drawer();
    if (!d) return;
    var fuss = d.querySelector('.drawer__footer, .cart-drawer__summary');
    if (!fuss) return;

    var helfer = d.querySelector('.cart-item .tax-price-helper');
    if (!helfer) return;
    var quelle = helfer.textContent.toLowerCase();
    var steuer;
    if (quelle.indexOf('inklusive') !== -1) steuer = 'inklusive MwSt.';
    else if (quelle.indexOf('exklusive') !== -1) steuer = 'exklusive MwSt.';
    else return;
    /* Die Steuerangabe fett - sie ist der Teil, auf den es ankommt. */
    var text = 'Alle Preise im Warenkorb <strong>' + steuer + '</strong> ' +
               'Versandkosten werden im Bestellabschluss berechnet.';

    /* Der Shop hat oben einen Umschalter Geschaeftskunde/Privatkunde. Wird
       er betaetigt, wechseln die Betraege an den Posten zwischen netto und
       brutto - dieser Satz muss mitwechseln. Deshalb wird er bei jedem
       Durchlauf neu gelesen und nicht nur einmal gesetzt. */
    var p = fuss.querySelector('.smw-steuerhinweis');
    if (!p) {
      p = document.createElement('p');
      p.className = 'smw-steuerhinweis';
      fuss.appendChild(p);
    }
    if (p.innerHTML !== text) p.innerHTML = text;
  }

  /* ---------- Netto oder brutto nach dem Nachzeichnen ----------
     Die MwSt.-Umschaltung macht die App T-Selector. Auf frisch gezeichnete
     Knoten wendet sie den Umschalter nicht noch einmal an: nach jeder
     Mengenaenderung standen wieder Nettobetraege da, waehrend darunter
     „inklusive MwSt." stand.

     Beide Betraege stehen seit dem 07.09.2026 am Knoten selbst, vom Server
     gerechnet (`data-b2b`, `data-b2c` in snippets/cart-items.liquid). Hier
     wird deshalb nur ausgewaehlt, nie gerechnet - anders als die App, die
     den angezeigten Text mit 1,19 multiplizierte und sich dabei selbst
     wieder ausloeste, bis aus 26 EUR 3.094.029 EUR wurden. */
  function preisModus() {
    var m = document.cookie.match(/(?:^|;\s*)pricingFormat=(b2b|b2c)/);
    if (m) return m[1];
    /* Kein Cookie: nehmen, was die App ausserhalb des Warenkorbs zeigt. */
    var aussen = document.querySelector('[data-pricing]:not(.price__current), .money[data-pricing]');
    return aussen && aussen.dataset.pricing === 'b2c' ? 'b2c' : 'b2b';
  }

  function nurZiffern(text) { return String(text).replace(/[^0-9]/g, ''); }

  function preiseAngleichen() {
    var modus = preisModus();
    var knoten = document.querySelectorAll('.price__current[data-b2b][data-b2c]');
    for (var i = 0; i < knoten.length; i++) {
      var el = knoten[i];
      if (!el.closest('cart-items, .drawer--cart, .cart-item')) continue;
      var soll = modus === 'b2c' ? el.dataset.b2c : el.dataset.b2b;
      var andere = modus === 'b2c' ? el.dataset.b2b : el.dataset.b2c;
      if (!soll || !andere) continue;
      var ist = nurZiffern(el.textContent);
      if (ist === nurZiffern(soll)) { el.dataset.pricing = modus; continue; }
      /* Nur eingreifen, wenn genau der Wert des ANDEREN Modus dasteht.
         Alles Uebrige gehoert einer anderen App - dem Mengenrabatt etwa -
         und wird nicht angefasst. */
      if (ist !== nurZiffern(andere)) continue;
      el.textContent = soll;
      el.dataset.pricing = modus;
    }
  }

  function sektionsKennung() {
    var d = drawer();
    var huelle = d && d.closest('[id^="shopify-section-"]');
    return huelle ? huelle.id.replace('shopify-section-', '') : null;
  }

  function stand() {
    /* Ohne `no-store` gab der Browser die vorige Antwort zurueck. Der
       Vergleich sah dann keine Aenderung, und die Postenliste wurde nie
       nachgezeichnet: Warenkorb 3 Posten, Ausklapper 2 - erst ein
       Neuladen brachte sie zusammen. */
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        return k.item_count + '|' + k.items.map(function (i) { return i.key + ':' + i.quantity; }).join(',');
      })
      .catch(function () { return null; });
  }

  /* Nur die Postenliste und der Fuss werden getauscht.

     Vorher wurde die ganze Sektionshuelle per innerHTML neu geschrieben -
     damit verschwand auch das Element <cart-drawer> selbst samt Kopfzeile
     und Schliessen-Knopf. Auf dem Telefon liess sich der Warenkorb danach
     nicht mehr zumachen: das Theme hielt seine Verbindung zum alten,
     inzwischen ersetzten Element. Kopf, Schliesser und Ueberlagerung
     bleiben jetzt unangetastet. */
  /* NUR die Postenliste. Der Fuss wird bewusst nicht angefasst: dort sitzen
     das Rabattfeld der App, der Versandhinweis, der Betrag im Kasse-Knopf -
     und ein <script> der Preisbruecke. Beim Austausch gingen die
     Ereignis-Verbindungen des Rabattfeldes verloren (der Code wurde nicht
     mehr uebernommen), und das eingefuegte Skript laeuft nicht erneut:
     die Betraege blieben danach in der Netto-Darstellung stehen, auch wenn
     der Umschalter auf brutto stand. */
  var TEILE = ['.drawer__content'];

  /* ---------- Der Fuss beim leeren Warenkorb ----------
     Shopify baut Kaufknopf, Rabattfeld und Versandkasten nur, wenn beim
     Seitenaufbau schon etwas im Warenkorb lag - die Vorlage kapselt sie
     in eine Bedingung auf einen nicht leeren Warenkorb.
     Wer mit leerem Warenkorb auf die Seite kam und dann etwas ablegte,
     sah zwar den Posten - aber keinen Knopf, kein Rabattfeld, keinen
     Versandbalken. Erst ein Neuladen brachte sie.

     Der Fuss wird deshalb NUR in diesen beiden Faellen angefasst:
     wenn er leer ist und jetzt gefuellt gehoert, und wenn der letzte
     Posten verschwunden ist. Solange er steht, bleibt er unberuehrt -
     ein Austausch im laufenden Betrieb kostete die Verbindungen des
     Rabattfeldes und liesse die Betraege in der Netto-Anzeige haengen. */
  function skripteBeleben(bereich) {
    /* Eingefuegte <script> fuehrt der Browser nicht aus. Wer sie laufen
       lassen will, muss sie neu erzeugen - sonst bleibt die Preisbruecke
       im neuen Fuss stumm. */
    var skripte = bereich.querySelectorAll('script');
    for (var i = 0; i < skripte.length; i++) {
      var alt = skripte[i];
      var frisch = document.createElement('script');
      for (var j = 0; j < alt.attributes.length; j++) {
        frisch.setAttribute(alt.attributes[j].name, alt.attributes[j].value);
      }
      frisch.text = alt.textContent;
      if (alt.parentNode) alt.parentNode.replaceChild(frisch, alt);
    }
  }

  function fussNachruesten(d, frischerDrawer) {
    var alt = d.querySelector('.cart-drawer__summary');
    var neu = frischerDrawer.querySelector('.cart-drawer__summary');
    if (!alt || !neu) return;

    var hatKnopf = !!alt.querySelector('.cart-drawer__checkout-buttons');
    var neuHatKnopf = !!neu.querySelector('.cart-drawer__checkout-buttons');

    /* Nichts zu tun: beide gefuellt oder beide leer. */
    if (hatKnopf === neuHatKnopf) return;

    alt.replaceWith(neu);
    if (neuHatKnopf) skripteBeleben(neu);
  }

  function neuZeichnen() {
    var kennung = sektionsKennung();
    var d = drawer();
    if (!kennung || !d) return;
    var schale = d.closest('.drawer--cart') || d;
    schale.classList.add('smw-laedt');

    fetch('/?sections=' + encodeURIComponent(kennung), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (teile) {
        var html = teile[kennung];
        if (!html) return;
        var frisch = new DOMParser().parseFromString(html, 'text/html');
        var frischerDrawer = frisch.querySelector('cart-drawer');
        if (!frischerDrawer) return;

        TEILE.forEach(function (sel) {
          var altes = d.querySelector(sel);
          var neues = frischerDrawer.querySelector(sel);
          if (altes && neues) altes.replaceWith(neues);
        });

        fussNachruesten(d, frischerDrawer);

        /* Zuerst die Betraege in den richtigen Modus, dann den Hinweis -
           der liest ab, was an den Posten steht. */
        preiseAngleichen();
        steuerhinweis();
        betragSetzen();
        codeHinweis();
        appZeileKante();
      })
      .catch(function () { })
      .then(function () {
        var s = document.querySelector('.drawer--cart');
        if (s) s.classList.remove('smw-laedt');
      });
  }

  /* Nach dem Absenden auf Aenderung warten und dann neu zeichnen. Hoechstens
     acht Sekunden, danach wird aufgegeben - eine Dauerabfrage waere
     schlimmer als ein nicht aktualisierter Ausklapper. */
  function beobachten() {
    stand().then(function (vorher) {
      if (vorher === null) return;
      var versuche = 0;
      var takt = setInterval(function () {
        versuche++;
        stand().then(function (jetzt) {
          if (jetzt !== null && jetzt !== vorher) {
            clearInterval(takt);
            neuZeichnen();
          } else if (versuche >= 16) {
            clearInterval(takt);
          }
        });
      }, 500);
    });
  }

  /* ---------- Abgleich ----------
     Das letzte Netz: was im Ausklapper steht, wird mit dem verglichen, was
     Shopify fuehrt. Weichen die Postenzahlen ab, wird neu gezeichnet. So
     faellt auch das durch, was wir gar nicht mitbekommen - etwa ein
     Ablegen ueber eine App oder einen Weg, den wir nicht abhoeren. */
  function abgleichen() {
    var d = drawer();
    if (!d) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        /* Verglichen werden ZEILEN, nicht Stueckzahlen: item_count zaehlt
           die Mengen zusammen (zwei Pakete derselben Ware = 2), im Bild
           steht dafuer aber nur eine Zeile. Wer das verwechselt, laesst
           den Warenkorb bei jeder Mengenerhoehung endlos neu zeichnen. */
        var imBild = d.querySelectorAll('.cart-item').length;
        var zeilen = (k.items || []).length;
        /* Zweiter Grund zum Nachzeichnen: die Posten stimmen, aber der
           Fuss ist leer geblieben (oder umgekehrt steht er noch, obwohl
           nichts mehr im Warenkorb liegt). */
        var hatKnopf = !!d.querySelector('.cart-drawer__checkout-buttons');
        if (zeilen !== imBild || (zeilen > 0) !== hatKnopf) neuZeichnen();
      })
      .catch(function () { });
  }

  function starten() {
    steuerhinweis();
    betragSetzen();
    codeHinweis();
    appZeileKante();
    versuchAuswerten();
    var d = drawer();
    if (d && window.MutationObserver) {
      new MutationObserver(function () { steuerhinweis(); betragSetzen(); codeHinweis(); appZeileKante(); })
        .observe(d, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  window.addEventListener('load', starten);

  /* ---------- Summe im Kasse-Knopf ----------
     Die Zahl der Preisbruecke wird verborgen (sie schreibt bei hohen
     Staffeln zwei Werte ineinander, siehe unten) und durch eine eigene
     ersetzt. Grundlage ist der Betrag, den Shopify selbst fuehrt; ob netto
     oder brutto gezeigt wird, richtet sich nach dem Umschalter - abgelesen
     an den Posten, nicht geraten.

     Nachgemessen am 04.09.2026: total_price ist der Betrag NACH einem
     eingeloesten Rabattcode - bei NEW5 also 19,00 statt 20,00 EUR. Der
     Knopf stimmt damit, aber am Posten steht weiter der Grundpreis;
     deshalb schreibt rabattZeigen() den Abzug als eigene Zeile darueber. */
  /* Der Steuermodus stammt aus dem Keks `pricingFormat` der Preisbruecke
     (b2c = inklusive). Zuvor wurde er an den Posten abgelesen - genau die
     baut das Theme beim Aendern der Menge neu, und in diesem Fenster
     zeigte die Summe dann netto statt brutto. Das DOM bleibt Rueckfall,
     falls der Keks einmal fehlt. */
  function bruttoModus() {
    var m = document.cookie.match(/(?:^|;\s*)pricingFormat=([^;]+)/);
    if (m) {
      var wert = decodeURIComponent(m[1]).toLowerCase();
      if (wert.indexOf('b2c') !== -1) return true;
      if (wert.indexOf('b2b') !== -1) return false;
    }
    var helfer = document.querySelector('cart-drawer .cart-item .tax-price-helper');
    return !!(helfer && /inklusive/i.test(helfer.textContent));
  }

  function betragSetzen() {
    var app = document.getElementById('smk-btn-price');
    if (!app || !app.parentElement) return;

    var eigen = app.parentElement.querySelector('.smw-summe');
    if (!eigen) {
      eigen = document.createElement('span');
      eigen.className = 'smw-summe';
      app.parentElement.insertBefore(eigen, app.nextSibling);
    }

    /* `no-store` ist hier nicht Zierde: ohne die Sperre gab der Browser
       nach dem Entfernen eines Codes die vorige Antwort aus dem Zwischen-
       speicher zurueck. Warenkorb 19,80 EUR, Anzeige aber weiter 18,81 -
       Rabattzeile, Knopfsumme und Versandbalken hingen am alten Stand. */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        var netto = k.total_price / 100;
        var brutto = bruttoModus();
        var wert = brutto ? netto * 1.19 : netto;
        var text = wert.toLocaleString('de-DE', {
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }) + ' \u20ac';
        if (eigen.textContent !== text) eigen.textContent = text;
        rabattZeigen(k, brutto);
      })
      .catch(function () { });
  }

  /* ---------- Anzeige des eingeloesten Codes ----------
     Nachgemessen am 04.09.2026: Die Rabatt-App zeigt ihre Plakette nur,
     wenn der Code ueber die EINGABETASTE kam. Beim Klick auf "Anwenden"
     erschien sie in sechs Sekunden Beobachtung kein einziges Mal - der
     Rabatt lag bei Shopify (23,52 statt 24,75 EUR) und griff im
     Bestellabschluss, im Warenkorb aber deutete nichts darauf hin.

     Deshalb springt hier eine eigene Anzeige ein - aber nur dann, wenn
     die App gerade keine zeigt. Sie traegt dieselben Klassennamen und
     damit denselben Stil, sodass beide Wege gleich aussehen; erkennbar
     ist sie allein am Merkmal data-smw. Taucht die App-Zeile spaeter doch
     auf, raeumt der naechste Durchlauf die eigene wieder ab, und es
     bleibt bei genau einer Zeile.

     Der Betrag stammt aus Shopifys Zahlen und folgt dem Steuerumschalter -
     anders als die App, die immer netto rechnet. */
  function rabattZeigen(k, brutto) {
    var abzug = 0, namen = [];
    (k.cart_level_discount_applications || []).forEach(function (d) {
      abzug += d.total_allocated_amount || 0;
      if (d.title && namen.indexOf(d.title) === -1) namen.push(d.title);
    });
    AKTIVER_CODE = namen.length ? namen[0] : '';

    /* Shopifys eigene Plakette in der Bestelluebersicht wird serverseitig
       gezeichnet und erneuert sich erst beim Neuladen: nach dem Entfernen
       stand der Code weiter da. Ab hier kennen wir den Stand aus
       /cart.js - die Plakette weicht, unsere Zeile uebernimmt. */
    var fremde_plakette = document.querySelector('.cart__summary .discount');
    var fremde_liste = fremde_plakette ? fremde_plakette.closest('ul') : null;
    if (fremde_liste) fremde_liste.classList.add('smw-doppelter-code');

    /* Eigene Klassennamen, nicht die der App: als die Zeile deren Namen
       trug, raeumte die App sie beim Neuzeichnen aus - uebrig blieb eine
       leere, unsichtbare Huelle ohne Code, Betrag und Kreuz. */
    var eigene = document.querySelector('.smw-codezeile');
    if (eigene && !eigene.querySelector('.smw-tag')) {
      /* ausgeraeumt oder halb gebaut - dann neu machen */
      if (eigene.parentNode) eigene.parentNode.removeChild(eigene);
      eigene = null;
    }

    var fremde = null;
    var alle = document.querySelectorAll('.hulkapps-summary-line-discount-code');
    for (var i = 0; i < alle.length; i++) {
      /* Nur eine App-Zeile MIT Inhalt zaehlt: die App laesst oft eine
         leere Huelle stehen, und dahinter duerfen wir nicht verschwinden. */
      if (alle[i].offsetParent !== null && (alle[i].textContent || '').trim()) fremde = alle[i];
    }

    function eigeneWeg() {
      if (eigene && eigene.parentNode) eigene.parentNode.removeChild(eigene);
    }

    /* Kein Nachlass, kein Platz dafuer - oder die App zeigt schon eine:
       dann hat die eigene hier nichts zu suchen. */
    var kasten = document.querySelector('.discount_code_box');
    if (!abzug || !kasten || fremde) { eigeneWeg(); return; }

    if (!eigene) {
      eigene = document.createElement('span');
      eigene.className = 'smw-codezeile';
      eigene.innerHTML =
        '<span class="smw-tag"><span class="smw-code"></span>' +
        '<span class="smw-kreuz" role="button" tabindex="0" ' +
        'aria-label="Rabattcode entfernen" title="Rabattcode entfernen">\u00d7</span></span>' +
        '<span class="smw-betrag"></span>';
      kasten.appendChild(eigene);
    }

    var wert = (abzug / 100) * (brutto ? 1.19 : 1);
    var betrag = '\u2212' + wert.toLocaleString('de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + '\u00a0\u20ac';
    var name = namen.join(', ');

    var n = eigene.querySelector('.smw-code');
    var w = eigene.querySelector('.smw-betrag');
    if (n && n.textContent !== name) n.textContent = name;
    if (w && w.textContent !== betrag) w.textContent = betrag;
    appZeileKante();
  }

  /* Das Kreuz - eigenes wie fremdes. Bei der App-Zeile raeumt ihr eigener
     Ablauf nur die Anzeige weg; der Code bliebe bei Shopify stehen.
     Deshalb laeuft in beiden Faellen unser Entfernen mit. */
  document.addEventListener('click', function (e) {
    var kreuz = e.target.closest ? e.target.closest('.smw-kreuz, .close-tag') : null;
    if (!kreuz) return;
    if (kreuz.classList.contains('smw-kreuz')) { e.preventDefault(); e.stopPropagation(); }
    codeEntfernen();
  }, true);

  /* ---------- Rabattcode anwenden und zurueckmelden ----------
     Das Feld der Rabatt-App zeigt den Nachlass nur an; in Shopifys
     Warenkorb kam er nicht an. Shopify setzt Codes ueber /discount/<code>,
     und das braucht einen echten Seitenaufruf - per fetch passiert nichts
     (nachgemessen: der Warenkorb blieb unveraendert).

     Also: Beim Klick auf "Anwenden" wird der Stand gemerkt und die Seite
     ueber den Rabattpfad neu geladen. Danach steht hier eine Rueckmeldung,
     ob der Code angenommen wurde, und der Nachlass als eigene Zeile. Die
     Summe im Knopf rechnet sich von selbst mit, weil sie aus /cart.js
     kommt. */
  /* Die App zeigt den angenommenen Code samt Betrag bereits selbst an
     ("NEW5 x  -108,50 EUR"). Eine zweite Meldung daneben waere dasselbe
     zweimal - deshalb steht hier nur noch, was fehlte: dass der Code
     ueberhaupt bei Shopify ankommt. */
  var MERKER = 'smwRabattVersuch';

  function codeHinweis() {
    var kasten = document.querySelector('.hulkapps_discount_hide') ||
                 document.querySelector('.discount_code_box');
    if (!kasten) return;
    var p = kasten.querySelector('.smw-code-hinweis');
    if (p) { hinweisKante(p); return; }
    p = document.createElement('p');
    p.className = 'smw-code-hinweis';
    p.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>' +
      '<path d="M12 11v5M12 8v.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '<span>Rabattcode bitte <b>hier im Warenkorb</b> eingeben \u2014 ' +
      'im Bestellabschluss nicht mehr m\u00f6glich.</span>';
    kasten.appendChild(p);
    hinweisKante(p);
  }

  /* Die Plakette der Rabatt-App laeuft ueber die ganze Kastenbreite,
     waehrend Feld und Knopf mittig darin sitzen. Ohne Ausgleich begaenne
     der Code 55 px weiter links als das Eingabefeld darueber. Gemessen
     statt geraten - dieselbe Rechnung wie beim Hinweis. */
  function appZeileKante() {
    var z = document.querySelector('.smw-codezeile') ||
            document.querySelector('.hulkapps-summary-line-discount-code');
    if (z) hinweisKante(z);
  }

  /* Feld und Knopf sitzen mittig im Kasten; der Hinweis laeuft ueber die
     ganze Breite und begaenne sonst weiter links als das Feld. Der
     Unterschied wird gemessen statt geraten - so stimmt die Kante auch,
     wenn sich die Breite aendert. */
  function hinweisKante(p) {
    var feld = document.querySelector('.hulkapps_discount_code');
    if (!feld) return;
    /* getBoundingClientRect().left ist die AUSSENkante - das bereits
       gesetzte Polster darf nicht noch einmal dazugezaehlt werden, sonst
       wandert der Text bei jedem Durchlauf weiter nach rechts. */
    var versatz = Math.round(feld.getBoundingClientRect().left -
                             p.getBoundingClientRect().left);
    if (versatz > 0 && versatz < 120) {
      p.style.paddingLeft = versatz + 'px';
      /* Rechts derselbe Abstand: der Textblock endet damit an der Kante des
         Knopfes und ragt nicht darueber hinaus. */
      p.style.paddingRight = versatz + 'px';
    } else {
      p.style.paddingLeft = '';
      p.style.paddingRight = '';
    }
  }

  function versuchAuswerten() {
    try { localStorage.removeItem(MERKER); } catch (e) { }
  }

  /* ---------- Code setzen, ohne die Seite zu laden ----------
     Frueher lud diese Stelle die Seite ueber /discount/<code> neu - nach
     einer Messung, die besagte, per fetch passiere nichts. Am 04.09.2026
     nachgemessen: es passiert doch etwas, wenn man das Ziel des
     Rabattpfades auf /cart.js legt und der Weiterleitung folgt. Die
     Antwort IST dann der neue Warenkorb (2000 -> 1900 mit NEW5).

     Also bleibt die Seite stehen: Code setzen, Antwort auswerten, Posten
     und Summe nachziehen. Ein unbekannter Code aendert nichts - und wird
     hier auch als solcher gemeldet, statt still zu verpuffen. */
  function codeMeldung(text, gut) {
    var kasten = document.querySelector('.hulkapps_discount_hide') ||
                 document.querySelector('.discount_code_box');
    if (!kasten) return;
    var m = kasten.querySelector('.smw-code-meldung');
    if (!text) { if (m) m.parentNode.removeChild(m); return; }
    if (!m) {
      m = document.createElement('p');
      m.className = 'smw-code-meldung';
      kasten.appendChild(m);
    }
    m.textContent = text;
    m.className = 'smw-code-meldung' + (gut ? ' ist-gut' : ' ist-schlecht');
  }

  function codeListe(k) {
    return (k.cart_level_discount_applications || []).map(function (d) {
      return (d.title || '').toLowerCase();
    });
  }

  function codeSetzen(code) {
    var knopf = document.querySelector('.hulkapps_discount_button');
    var feld = document.querySelector('.hulkapps_discount_code');
    var beschriftung = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = 'Pr\u00fcfe \u2026'; }
    codeMeldung('');

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (vorher) {
        var vorCodes = codeListe(vorher);
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js',
                     { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (nachher) {
            var jetzt = codeListe(nachher);
            var angenommen = jetzt.indexOf(code.toLowerCase()) !== -1 ||
                             jetzt.length > vorCodes.length;
            if (angenommen) {
              /* Das Feld bleibt stehen: die Rabatt-App liest es fuer ihre
                 eigene Plakette aus. Leerte man es hier, verschwand dort
                 der Code. Keine Erfolgsmeldung - Plakette und gefallene
                 Summe sagen es deutlicher. */
              codeMeldung('');
            } else {
              codeMeldung('Dieser Code gilt f\u00fcr diesen Warenkorb nicht.', false);
            }
            betragSetzen();
            neuZeichnen();
            setTimeout(betragSetzen, 700);
            setTimeout(betragSetzen, 1600);
          });
      })
      .catch(function () {
        codeMeldung('Der Code konnte gerade nicht gepr\u00fcft werden.', false);
      })
      .then(function () {
        if (knopf) { knopf.disabled = false; knopf.textContent = beschriftung || 'Anwenden'; }
      });
  }

  /* ---------- Code wieder entfernen ----------
     Shopify bietet dem Warenkorb keinen Weg dafuer an: der Code haengt an
     der Sitzung, nicht am Cookie. Nachgemessen - weder das Leeren des
     Warenkorbs noch das Loeschen des Cookies `discount_code` noch ein
     falscher Code loesen ihn.

     Was wirkt, ist ein neuer Warenkorb-Schluessel: Posten merken, das
     `cart`-Cookie verwerfen, Posten sofort wieder einlegen. Die Sitzung
     ist damit frisch und der Nachlass fort (nachgemessen: 1900 -> 2000,
     Posten erhalten). Vor dem Wurf werden die Posten zusaetzlich lokal
     gesichert, damit nichts verloren geht, falls das Einlegen scheitert. */
  var RETTUNG = 'smwWarenkorbRettung';
  var AKTIVER_CODE = '';

  function postenAusLesen(k) {
    return (k.items || []).map(function (i) {
      var o = { id: i.variant_id, quantity: i.quantity };
      if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
      if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) {
        o.selling_plan = i.selling_plan_allocation.selling_plan.id;
      }
      return o;
    });
  }

  function codeEntfernen() {

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        var posten = postenAusLesen(k);
        try { localStorage.setItem(RETTUNG, JSON.stringify(posten)); } catch (e) { }

        ['cart', 'discount_code'].forEach(function (n) {
          document.cookie = n + '=; Max-Age=0; path=/';
        });

        if (!posten.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: posten })
        }).then(function (r) {
          if (!r.ok) throw new Error('einlegen');
          return r.json();
        });
      })
      .then(function () {
        try { localStorage.removeItem(RETTUNG); } catch (e) { }
        /* Keine Meldung: dass die Summe steigt, ist Rueckmeldung genug. */
        codeMeldung('');
        betragSetzen();
        neuZeichnen();
        /* Das Theme zeichnet den Fuss nach dem Neu-Einlegen noch einmal
           nach; zwei spaete Durchlaeufe holen die Anzeige dort ab. */
        setTimeout(betragSetzen, 700);
        setTimeout(betragSetzen, 1600);
      })
      .catch(function () {
        codeMeldung('Der Code wurde entfernt, die Posten konnten aber nicht ' +
                    'neu eingelegt werden. Bitte die Seite neu laden.', false);
      })
      .then(function () { });
  }

  window.smwCodeEntfernen = codeEntfernen;

  /* ---------- Absenden des Feldes ----------
     Nachgemessen am 04.09.2026: Wer den Code mit der EINGABETASTE
     abschickt, loeste nur den Ablauf der Rabatt-App aus. Die haengt dann
     ihre Plakette an ("new5" mit Kreuz und rotem Betrag) - in Shopifys
     Warenkorb aber stand kein Nachlass: Summe unveraendert 24,75 EUR,
     Kaufknopf 29,45 EUR. Die Plakette zeigte einen Rabatt, den es nicht
     gab, und an der Kasse wurde entsprechend nichts abgezogen.

     Der Klick auf "Anwenden" wurde umgekehrt bisher ganz abgefangen, die
     App sah ihn nie - deshalb erschien ihre Plakette dort nicht.

     Jetzt gilt fuer beide Wege dasselbe: die App macht ihren Ablauf wie
     gewohnt (und zeigt ihre Plakette), und zusaetzlich wird der Code bei
     Shopify hinterlegt, damit er auch wirklich zaehlt. */
  var LETZTER_VERSUCH = { code: '', zeit: 0 };

  function absenden(code) {
    if (!code) return;
    var jetzt = Date.now();
    /* Eingabetaste und Klick koennen beide feuern - derselbe Code binnen
       anderthalb Sekunden wird nur einmal gesetzt. */
    if (LETZTER_VERSUCH.code === code && jetzt - LETZTER_VERSUCH.zeit < 1500) return;
    LETZTER_VERSUCH = { code: code, zeit: jetzt };
    codeSetzen(code);
  }

  document.addEventListener('click', function (e) {
    var anwenden = e.target.closest ? e.target.closest('.hulkapps_discount_button') : null;
    if (!anwenden) return;
    var feld = document.querySelector('.hulkapps_discount_code');
    absenden(feld && feld.value ? feld.value.trim() : '');
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var feld = e.target.closest ? e.target.closest('.hulkapps_discount_code') : null;
    if (!feld) return;
    absenden(feld.value ? feld.value.trim() : '');
  }, true);

  /* ---------- Der Weg zur Kasse ----------
     Nachgemessen am 04.09.2026 - es gibt zwei Wege, und sie schliessen
     einander aus:

       Kaufknopf (Formular der Rabatt-App)  ->  /checkouts/do/...
         Das ist ein Entwurfsauftrag. Er traegt den Mengenrabatt
         (50 Pakete: 247,50 -> 240,00 EUR), nimmt aber KEINEN Rabattcode
         mit - der eingeloeste Code fiel dort still unter den Tisch.

       Aufruf von /checkout                 ->  /checkouts/cn/...
         Shopifys eigener Warenkorb-Checkout. Hier greift der Code
         (TREUE10: -1,98 EUR), dafuer fehlt der Mengenrabatt.

     Deshalb wird nur dann umgeleitet, wenn wirklich ein Code im Spiel ist -
     der Kunde hat ihn bewusst eingegeben. Liegt keiner vor, bleibt alles
     beim Alten und der Mengenrabatt kommt wie gewohnt zustande. */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!knopf) return;

    /* Noch nicht angewendeter Code im Feld: erst setzen, dann zur Kasse -
       das erledigt Shopifys Rabattpfad in einem Schritt. */
    var feld = document.querySelector('.hulkapps_discount_code');
    var code = feld && feld.value ? feld.value.trim() : '';
    if (code) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
      return;
    }

    /* Bereits eingeloester Code: am Formular vorbei zum Warenkorb-Checkout,
       sonst geht er im Entwurfsauftrag verloren. */
    if (AKTIVER_CODE) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/checkout';
    }
  }, true);

  document.addEventListener('click', function (e) {
    var ziel = e.target.closest ? e.target.closest('[href="/cart"], .header__icon--cart-shake, .smk-toggle-side') : null;
    if (!ziel) return;
    setTimeout(betragSetzen, 700);
    setTimeout(abgleichen, 400);
    setTimeout(abgleichen, 1500);
  }, true);

  /* Und immer dann, wenn der Ausklapper aufgeht - unabhaengig davon,
     worauf geklickt wurde. */
  (function () {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function (aenderungen) {
      aenderungen.forEach(function (a) {
        if (a.attributeName === 'aria-hidden' && d.getAttribute('aria-hidden') === 'false') {
          setTimeout(abgleichen, 300);
        }
      });
    }).observe(d, { attributes: true });
  })();

  /* ---------- Rabattfeld: deutsche Beschriftung, Hausgestaltung ----------
     Die Rabatt-App liefert „Discount code" und „Apply" - der einzige
     englische Text auf einer deutschen Seite, und ausgerechnet dort, wo der
     Kunde etwas eingeben soll. Beides wird hier gesetzt; die Klasse am
     Kasten schaltet die Gestaltung zu.

     Wird bei jedem Durchlauf geprueft, weil die App ihren Kasten nach dem
     Anwenden eines Codes neu aufbaut. */
  function rabattfeldHerrichten() {
    var kasten = document.querySelector('.discount_code_box');
    if (kasten && !kasten.classList.contains('smw-rabattkasten')) {
      kasten.classList.add('smw-rabattkasten');
    }
    if (kasten && !kasten.querySelector('.smw-rabatt-titel')) {
      var titel = document.createElement('span');
      titel.className = 'smw-rabatt-titel';
      titel.textContent = 'Rabattcode';
      kasten.insertBefore(titel, kasten.firstChild);
    }
    var feld = document.querySelector('.hulkapps_discount_code');
    if (feld && feld.getAttribute('placeholder') !== 'Rabattcode eingeben') {
      feld.setAttribute('placeholder', 'Rabattcode eingeben');
      feld.setAttribute('aria-label', 'Rabattcode');
    }
    var knopf = document.querySelector('.hulkapps_discount_button');
    if (knopf && knopf.textContent.trim() !== 'Anwenden') {
      knopf.textContent = 'Anwenden';
    }
  }

  /* ---------- Eingeloester Code auf der Warenkorbseite ----------
     Die Plakette mit dem Kreuz baut `rabattZeigen`, aufgerufen von
     `betragSetzen` - und das steigt sofort aus, wenn `#smk-btn-price`
     fehlt. Dieses Element gibt es nur im Ausklapper, auf /cart lief also
     nie etwas: der Code war weder zu sehen noch zu entfernen.

     Gedrosselt auf hoechstens einen Abruf je anderthalb Sekunden - der
     Beobachter loest bei jeder Aenderung im Warenkorb aus, und /cart.js
     soll davon nicht ueberrannt werden. */
  var rabattZuletzt = 0;
  function rabattStandHolen(sofort) {
    if (!document.querySelector('.cart__summary .discount_code_box')) return;
    var jetzt = Date.now();
    if (!sofort && jetzt - rabattZuletzt < 1500) return;
    rabattZuletzt = jetzt;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (kk) { rabattZeigen(kk, bruttoModus()); })
      .catch(function () { });
  }

  /* Zahl der Positionen unter der Ueberschrift. */
  function korbUeberschrift() {
    var titel = document.querySelector('.cart__items > .js-cart-title');
    if (!titel) return;
    var posten = document.querySelectorAll('cart-items .cart-item').length;
    if (!posten) return;
    var zusatz = titel.parentElement.querySelector('.smw-korb-zusatz');
    if (!zusatz) {
      zusatz = document.createElement('span');
      zusatz.className = 'smw-korb-zusatz';
      titel.insertAdjacentElement('afterend', zusatz);
    }
    var text = posten === 1 ? '1 Position' : posten + ' Positionen';
    if (zusatz.textContent !== text) zusatz.textContent = text;
  }

  /* ---------- Der Betrag der Rabatt-App ist netto ----------
     Er traegt keine `data-b2b`/`data-b2c`-Merker, die MwSt.-Umschaltung
     laesst ihn deshalb unangetastet. Im Bruttomodus stand dort ein
     Nettobetrag: 425,00 EUR angezeigt, 505,75 EUR an der Kasse.

     Der Knoten der App wird NICHT beschrieben, nur ausgeblendet - daneben
     steht ein eigener. Damit kann sich nichts aufschaukeln: es wird nie
     aus dem eigenen Ergebnis weitergerechnet. */
  function betragZahl(text) {
    var t = String(text).replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    var z = parseFloat(t);
    return isFinite(z) ? z : NaN;
  }

  function summeUmrechnen(zeile) {
    var app = zeile.querySelector('.hulkapps-cart-total');
    var alt = zeile.querySelector('[data-b2b][data-b2c]');
    var eigen = zeile.querySelector('.smw-summe-neu');
    if (!app || !alt || preisModus() !== 'b2c') {
      zeile.classList.remove('smw-hat-brutto');
      if (eigen) eigen.parentNode.removeChild(eigen);
      return;
    }

    var netto = betragZahl(app.textContent);
    var vorherNetto = betragZahl(alt.dataset.b2b);
    var vorherBrutto = betragZahl(alt.dataset.b2c);
    if (!(netto > 0) || !(vorherNetto > 0) || !(vorherBrutto > 0)) {
      zeile.classList.remove('smw-hat-brutto');
      return;
    }
    var faktor = vorherBrutto / vorherNetto;
    /* Sicherung: ein Steuersatz liegt zwischen 0 und 50 %. Passt das
       Verhaeltnis nicht, bleibt der Betrag der App stehen. */
    if (!(faktor > 1 && faktor < 1.5)) {
      zeile.classList.remove('smw-hat-brutto');
      return;
    }

    var brutto = Math.round(netto * faktor * 100) / 100;
    var text = brutto.toLocaleString('de-DE',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0\u20ac';

    if (!eigen) {
      eigen = document.createElement('span');
      eigen.className = 'smw-summe-neu';
      var gruppe = zeile.querySelector('.smw-betraege') || zeile;
      gruppe.appendChild(eigen);
    }
    if (eigen.textContent !== text) eigen.textContent = text;
    zeile.classList.add('smw-hat-brutto');
  }

  /* ---------- Bestelluebersicht auf der Warenkorbseite ----------
     Das Rabattfeld stand unter der Postenliste, links, weit weg vom Preis.
     Wer einen Code hat, sucht ihn dort, wo er zahlt. Es wandert deshalb in
     die Uebersicht, zwischen Zwischensumme und Kaufknopf.

     Verschoben statt nachgebaut: Das Feld gehoert der Rabatt-App, ein
     Nachbau verlöre ihre Ereignis-Verbindungen. `appendChild` an anderer
     Stelle behaelt sie. */
  function uebersichtHerrichten() {
    var uebersicht = document.querySelector('.cart__summary');
    if (!uebersicht) return;

    /* Die Summenzeile erkennt man am Betrag der Rabatt-App darin.
       ACHTUNG: nicht ueber `parentElement` - sobald die Betraege in ihrer
       Huelle stecken, ist deren Elternteil die Huelle und nicht die Zeile.
       Deshalb am gesetzten Merkmal suchen. */
    var betrag = uebersicht.querySelector('[data-hulkapps-cart-total]');
    var zeile = betrag && betrag.closest('.smw-summenzeile');
    if (!zeile && betrag) {
      zeile = betrag.parentElement;
      zeile.classList.add('smw-summenzeile');
    }
    /* Die beiden Betraege in eine Huelle, damit sie beim Umbruch
       zusammenbleiben. Verschoben, nicht nachgebaut - an dem einen haengen
       die Merker der MwSt.-Umschaltung, am anderen die der Rabatt-App. */
    if (zeile && !zeile.querySelector('.smw-betraege')) {
      var alt = zeile.querySelector('[data-hulkapps-cart-total]');
      var neuBetrag = zeile.querySelector('.hulkapps-cart-total');
      if (alt) {
        var huelle = document.createElement('span');
        huelle.className = 'smw-betraege';
        alt.parentNode.insertBefore(huelle, alt);
        huelle.appendChild(alt);
        if (neuBetrag) huelle.appendChild(neuBetrag);
      }
    }

    /* Eigener Steuerhinweis unter der Zwischensumme. Die App liefert ihren
       mal einmal, mal zweimal und mal gar nicht - dieser ist immer da und
       folgt dem Umschalter. */
    if (zeile) {
      /* Ueberzaehlige wegraeumen - siehe Kommentar oben. */
      var alle = zeile.querySelectorAll('.smw-summe-steuer');
      for (var i = 1; i < alle.length; i++) alle[i].parentNode.removeChild(alle[i]);
      var hinweis = alle[0] || null;
      if (!hinweis) {
        hinweis = document.createElement('span');
        hinweis.className = 'smw-summe-steuer';
        zeile.appendChild(hinweis);
      }
      var soll = preisModus() === 'b2c'
        ? 'Preise inklusive MwSt.'
        : 'Preise zzgl. MwSt.';
      if (hinweis.textContent !== soll) hinweis.textContent = soll;

      summeUmrechnen(zeile);
    }

    var knoepfe = uebersicht.querySelector('.dynamic-cart-btns');
    if (knoepfe && !knoepfe.classList.contains('smw-zahlwege')) {
      knoepfe.classList.add('smw-zahlwege');
    }

    /* Der Kasten steht auf der Warenkorbseite; im Ausklapper sitzt er
       schon richtig und wird nicht angefasst. */
    var kasten = document.querySelector('.cart__items .discount_code_box') ||
                 document.querySelector('form.cart .discount_code_box');
    if (!kasten || kasten.closest('cart-drawer, .drawer--cart')) return;
    if (kasten.parentElement === uebersicht) return;

    var kaufknopf = uebersicht.querySelector('button[name="checkout"]');
    var vorAnker = kaufknopf ? kaufknopf.closest('.cart__summary > *') : null;
    if (vorAnker) uebersicht.insertBefore(kasten, vorAnker);
    else uebersicht.appendChild(kasten);
  }

  /* ---------- Wache ueber die Betraege ----------
     Mengenaenderungen mit + und - zeichnet das Theme selbst; `neuZeichnen`
     laeuft dabei nicht. Gemessen am 07.09.2026: nach jedem Klick standen ein
     bis zwei Sekunden lang Nettobetraege unter der Zeile „inklusive MwSt.",
     bis die App von sich aus umrechnete - und blieb sie aus, standen sie
     dauerhaft falsch.

     Ein Aufschaukeln ist hier ausgeschlossen: `preiseAngleichen` waehlt nur
     zwischen den beiden feststehenden Werten am Knoten und schreibt nichts,
     wenn der richtige schon dasteht. Der Beobachter loest sich also nicht
     selbst wieder aus. */
  (function smwPreisWache() {
    if (!window.MutationObserver) return;
    var wartet = null;
    function durchlauf() {
      preiseAngleichen(); steuerhinweis();
      uebersichtHerrichten(); rabattfeldHerrichten();
      korbUeberschrift(); rabattStandHolen(false);
    }
    /* Drei Apps schreiben nacheinander in dieselben Knoten. Ein einzelner
       Durchlauf kommt zu frueh - die naechste App schreibt danach noch
       einmal. Deshalb zwei Nachlaeufe, wenn die Schreibwelle abklingt. */
    function anstossen() {
      if (wartet) clearTimeout(wartet);
      wartet = setTimeout(function () {
        durchlauf();
        setTimeout(durchlauf, 400);
        setTimeout(durchlauf, 1200);
      }, 40);
    }
    var wache = new MutationObserver(anstossen);
    function anhaengen() {
      var ziele = document.querySelectorAll('cart-drawer, cart-items, .drawer--cart, .cart__summary');
      for (var i = 0; i < ziele.length; i++) {
        wache.observe(ziele[i], { childList: true, subtree: true });
      }
      return ziele.length > 0;
    }
    if (!anhaengen()) {
      var versuche = 0;
      var takt = setInterval(function () {
        versuche++;
        if (anhaengen() || versuche > 40) clearInterval(takt);
      }, 150);
    }
    /* Auch der Umschalter im Kopf aendert den Modus. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#smkOwnToggle, [data-vat-type]')) {
        setTimeout(anstossen, 150);
        setTimeout(anstossen, 600);
      }
    }, true);
    uebersichtHerrichten(); rabattfeldHerrichten();
    [300, 1200, 3000].forEach(function (ms) {
      setTimeout(function () { uebersichtHerrichten(); rabattfeldHerrichten(); }, ms);
    });
    anstossen();
  })();

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var ziel = f.getAttribute('action') || '';
    if (ziel.indexOf('/cart/add') !== -1) beobachten();
  }, true);

  /* Die Knoepfe auf den Produktkarten legen ohne Formular ab. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.smk2-atc, [name="add"]') : null;
    if (b) beobachten();
  }, true);
})();